module.exports = __webpack_public_path__ + "static/media/ds_banner.9a8a6223.jpg";